import { EventEmitter, Injectable, ViewContainerRef, inject } from '@angular/core';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable, throwError as observableThrowError } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private logger = inject(LoggerService);

  public messageStore: BehaviorSubject<ErrorMessage[]> = new BehaviorSubject<ErrorMessage[]>([]);
  public showErrorsEvent: EventEmitter<any> = new EventEmitter<any>();

  public clearErrors() {
    this.messageStore.getValue().length = 0;
  }

  error(message: string, error?: Error): Observable<ErrorMessage> {
    let snackbar: MatSnackBarRef<SimpleSnackBar> = this.logger.error(message, error);
    let msg = new ErrorMessage(message, 'error', error);
    this.addOne(msg);
    let sub = snackbar.onAction().subscribe(() => {
      this.showErrorsEvent.emit(true);
    });
    snackbar.afterDismissed().subscribe(() => {
      sub.unsubscribe();
    })
    console.error(message, error);

    return observableThrowError(new Error(msg.message));
  }

  async errorasync(message: string, error?: Error): Promise<ErrorMessage> {
    let snackbar: MatSnackBarRef<SimpleSnackBar> = this.logger.error(message, error);
    let sub = snackbar.onAction().subscribe(() => {
      this.showErrorsEvent.emit(true);
    });
    snackbar.afterDismissed().subscribe(() => {
      sub.unsubscribe();
    })
    let msg = new ErrorMessage(message, 'error', error);
    this.addOne(msg);
    return Promise.resolve(msg);
  }

  display(message: string, viewContainer?: ViewContainerRef, showPopup: boolean = true) {
    
    if (showPopup) {
      let snackbar: MatSnackBarRef<SimpleSnackBar> = this.logger.message(message, viewContainer);
      let sub = snackbar.onAction().subscribe(() => {
        this.showErrorsEvent.emit(true);
      });
      snackbar.afterDismissed().subscribe(() => {
        sub.unsubscribe();
      })
    }
    this.addOne(new ErrorMessage(message, 'message'));
  }

  handleHTTPErrorWithMessage(bad, optionalMessage?: string): Observable<never> {
    let error: Error;
    let msg: string;
    try {
      let json = bad;
      let msgObj;

      if (json.error && json.error instanceof ProgressEvent) {
        msgObj = json.Message || json.message;
      }
      else if (json.message) {
        msgObj = json.message;
        if (json.error && (typeof msgObj == 'string')) {
          msgObj += '\nError:' + json.error;
        }
      } else {
        msgObj = json.error || json.Error || json.ExceptionMessage || json.Message || json.message;
      }

      if (msgObj && msgObj.error) {
        msgObj = msgObj.error;
      }
      if (msgObj && msgObj.message) {
        msg = msgObj.message;
      } else if (msgObj && msgObj.Message) {
        msg = msgObj.Message;
      }
      else if (msgObj && msgObj.detail) {
        msg = msgObj.detail;
      }

      if (!msg && typeof msgObj === 'undefined') {
        msg = json.Message || json.message;
      }
      if (msgObj && msgObj.innererror) {
        msg += ' ' + msgObj.innererror.message;
      }
      else if (msgObj && msgObj.MessageDetails) {
        msg += ' ' + msgObj.MessageDetails;
      } else if (msgObj && msgObj.ExceptionMessage) {
        msg += ' ' + msgObj.ExceptionMessage;
      }
      if (!msg) {
        msg = msgObj;
      }
    } catch (ex) {
      try {
        msg = bad.text();
      } catch (ex2) {
        try {
          msg = bad.status + ':' + bad.statusText;
        } catch (ex3) {
          msg = 'Server Error';
        }
      }
    }
    if (!msg) {
      msg = 'Unknown  / Unhandled Exception';
    }

    optionalMessage = optionalMessage || '';
    if (optionalMessage) {
      optionalMessage = optionalMessage + ' ';
    }
    error = new Error(msg);
    this.error(optionalMessage + msg, error);
    return observableThrowError(error); // Observable.throw() is undefined at runtime using Webpack
  }
  handleHTTPError(bad) {
    return this.handleHTTPErrorWithMessage(bad);
  }
  private addOne(msg: ErrorMessage) {
    this.messageStore.next(this.messageStore.getValue().concat(msg));
  }
}

export class ErrorMessage {
  private recurseInnerExceptions(msg: string, error: any): string {
    if (error && error.ExceptionMessage) {
      msg += error.ExceptionMessage;
    } else if (error && error.Message) {
      msg += error.Message;
    }
    if (error && error.InnerException) {
      return this.recurseInnerExceptions(msg + '>>>', error.InnerException);
    } else {
      if (error && error.StackTrace) {
        console.error(error.StackTrace);
      }
      return msg;
    }
  }
  public error: string;
  public subError: string;
  constructor(public message: string, public messageType: 'message' | 'error', public exception: Error = null) {
    if (exception) {
      this.error = exception.message;
      let ex: any = exception;
      this.subError = this.recurseInnerExceptions('', ex.error);
    }
  }
}